module.exports = __webpack_public_path__ + "fonts/EuclidSquare-Medium.woff2";